import './icon-waveform.scss';

import { h } from 'preact';

export function IconWaveform({
  width = 22,
  height = 22,
  fill = 'currentColor',
  animated = false,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 640"
      width={width}
      height={height}
      class={`icon-waveform${animated ? ' animated' : ''}`}
    >
      <rect x="52"  y="288" width="56" height="64"  rx="28" fill={fill} />
      <rect x="148" y="192" width="56" height="256" rx="28" fill={fill} />
      <rect x="244" y="96"  width="56" height="448" rx="28" fill={fill} />
      <rect x="340" y="224" width="56" height="192" rx="28" fill={fill} />
      <rect x="436" y="160" width="56" height="320" rx="28" fill={fill} />
      <rect x="532" y="288" width="56" height="64"  rx="28" fill={fill} />
    </svg>
  );
}
